import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import EntityIcon from "../../components/EntityIcon/EntityIcon";
import Feedback from "../../components/Feedback/Feedback";
import Api from '../../api/Api';
import auth from '../../services/authentication';
import SearchStore from '../../xstores/search';
import {Gmail, Slack, Dropbox, GDrive, Jira, Office} from './platforms';
import {Box} from '../../styled';
import styled from 'styled-components';

interface ResultItemProps {
  item: any;
  subscriptions?: any;
  isMarked?: boolean;
  mark?: Function;
  queryTs?: string | undefined;
  highlightWords: Array<any>;
  onClick: Function;
}
interface ItemProps{
  item: any;
  isPreview?: boolean;
  highlight?: Array<any>;
}
interface IPlatforms{
  [key:string]: any,
}

const platforms:IPlatforms = {
  gmail: Gmail,
  slack: Slack,
  dropbox: Dropbox,
  gdrive: GDrive,
  jira: Jira,
  'office-365': Office,
}

const ResultContainer = styled(Box)`
  & .code-preview{
    max-width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    white-space: pre-wrap;
    font-family: monospace;
    padding: 5px 10px;
    background-color: #fafafa;
  }
`

export const ResultBody = ({item, isPreview}:ItemProps) => {
  const ItemBody = platforms[item.pl];
  if (ItemBody) {
    return <ItemBody item={item} isPreview={!!isPreview} />
  }
  console.info('No element defined for platform', item.pl);
  let resBody = item.title || null;
  return resBody;
}

const ResultItem = ({item, onClick}:ResultItemProps) => {
  const location = useLocation();
  const trackClick = () => {
    const currentSearch = queryString.parse(location.search);
    if (currentSearch && currentSearch.q) {
      Api.trackClick({
        search_id: SearchStore.searchId$.getValue(),
        trova_id: auth.getUserData().trova_id,
        result_id: item.result_id,
        query: currentSearch.q,
      })
    }
  }
  const showDetails = () => {
    trackClick();
    if (item['o365-platform'] === 'contacts') {
      return;
    }
    onClick(item);
  }

  return (
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        p="32px 0"
      >
        <Box mt={10}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <ResultContainer
          flex="1"
          overflow="hidden"
          marginY={0}
          marginX={[0, 23]}
          onClick={showDetails}
        >
          <ResultBody item={item} />
        </ResultContainer>
        <Box
          display="flex"
          justifyContent="flex-end"
          alignSelf="flex-start"
          position="relative"
          height="100%"
          width={[30, 80]}
          flexDirection={['column', 'row']}
        >
          <Feedback item={item} feedback={item.feedback} />
          {/*<ResultBookmark
            isMarked={isMarked}
            onClick={bookmarkItem}
          />*/}
        </Box>
      </Box>
  )
}

export default ResultItem;